import { BrandTemplateData } from './BrandTemplatePreview.type';

export const previewBrandTemplateCache = new Map<string, BrandTemplateData>();

export const addLatestBrandTemplate = (brandData: BrandTemplateData) => {
  previewBrandTemplateCache.set('latest', brandData);
};

export const getLatestBrandTemplate = () => {
  return previewBrandTemplateCache.get('latest');
};
